import { ReactNode } from 'react';
import { View } from 'react-native';

import { styles } from './styles';

export const Card = ({ children }: { children: ReactNode }) => {
  return <View style={styles.card}>{children}</View>;
};
